export default __webpack_public_path__ + "static/media/logo.d796718d.png";